import React from 'react';
import { IFilterValues } from './types';

export const FilterContext = React.createContext({
  batchUpdate: (filters: IFilterValues) => {
    // noop
  },
  handleChange: (filterName: string, filterValue: any) => {
    // noop
  },
  values: {} as IFilterValues
});

export default FilterContext;
